import { Button, createTheme, ThemeProvider } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { BASE_THEME } from '@cibo/ui'
import AppleIcon from '@mui/icons-material/Apple'

const APPLE_THEME = createTheme({
  palette: {
    primary: {
      main: '#000',
    },
  },
  ...BASE_THEME,
})

export default (props: { onPress(): void }) => {
  const { t } = useTranslation('auth0')

  return (
    <ThemeProvider theme={APPLE_THEME}>
      <Button
        data-testid="auth0_apple_button"
        onClick={props.onPress}
        size="large"
        startIcon={<AppleIcon />}
        variant="contained"
      >
        {t('appleButton')}
      </Button>
    </ThemeProvider>
  )
}
